<template>
    <ul class="bank-list">
        <li v-for="bank in filteredBanks" :key="bank.authorizationServerId" class="bank-list__item">
            <button class="bank-list__btn-info" @click="selectBank(bank)" tabindex="0">
                <img :src="bank.customerFriendlyLogoUri" :alt="`Logo do ${bank.customerFriendlyName}`" class="bank-list__logo" tabindex="-1" />
                <h3 class="bank-list__name" tabindex="0">
                    {{ bank.customerFriendlyName }}
                </h3>
                <img class="bank-list__chevron" src="@/assets/img/icons/arrow-right-gray.svg" alt="" tabindex="-1" />
            </button>
        </li>
    </ul>
</template>

  <script>
  export default {
	props: {
	  banks: {
		type: Array,
		required: true
	  },
	  filterQuery: {
		type: String,
		default: ''
	  }
	},
	computed: {
	  filteredBanks() {
		return this.banks.filter(bank =>
		  bank.customerFriendlyName.toLowerCase().includes(this.filterQuery.toLowerCase())
		);
	  }
	},
	methods: {
		selectBank(bank) {
			this.$emit('select-bank', bank);
		}
	}
  };
  </script>

  <style lang="scss" scoped>
  .bank-list {
	height: 50vh;
	overflow-y: auto;
	padding-right: 12px;
	padding-left: 0;
	&__item {
	  display: flex;
	  align-items: center;
	  position: relative;
	  border-bottom: 1.5px solid #B8C1CC;
	  cursor: pointer;

	  &:last-child {
		border-bottom: none;
	  }

	  &:hover {
		background-color: #EFF1F3;
	  }
	}

	&__logo {
	  width: 40px;
	  height: 40px;
	  margin-right: 20px;
	}

	&__btn-info {
		display: flex;
		align-items: center;
		flex-grow: 1;
		position: relative;
		padding: 20px 0px;
		background-color: transparent;
		border: none;
		width: 100%;
	}

	&__name {
	  font-size: 16px;
	  font-weight: 500;
	  color: #2F363E;
	  margin: 0;
	  line-height: 24px;
	}

	&__arrow {
	  width: 20px;
	  height: 20px;
	}
	&__chevron {
		position: absolute;
		right: 0;
	}
  }
  </style>
